import React, { Component } from 'react';
import _ from 'lodash';
import { Auth } from 'aws-amplify';
// import cn from 'classnames'
import './Chat.scss';

import ChatMessage from './ChatMessage';

import { getRecentMessages } from '../../api/admin';
import { getE2ETestCsrfToken, isE2ETest } from '../../Auth';
import { isDevelopment, parseJson } from '../../helpers/helpers';

const MAX_RECONNECT_ATTEMPTS = 10;
export const ADMIN_WEBSOCKET_PROTOCOL = 'shopmy-admin-v1';
export const ADMIN_WEBSOCKET_AUTH_PROTOCOL_PREFIX = 'shopmy-admin-auth.';

class Chat extends Component {
  componentDidMount = () => {
    this.isUnmounted = false;
    this.reconnectAttempt = 0;
    this.connectToWSS();
    getRecentMessages().then(messages => {
      if (!this.isUnmounted) this.setState({ messages });
    });
  };

  componentWillUnmount = () => {
    this.isUnmounted = true;
    clearTimeout(this.reconnectTimer);
    this.reconnectTimer = null;
    if (!this.websocket) return;

    this.websocket.onopen = null;
    this.websocket.onclose = null;
    this.websocket.onerror = null;
    this.websocket.onmessage = null;
    this.websocket.close();
    this.websocket = null;
  };

  connectToWSS = async () => {
    try {
      const { websocketURL, protocols } = await getAdminWebSocketOptions();
      if (this.isUnmounted) return;

      const websocket = protocols ? new WebSocket(websocketURL, protocols) : new WebSocket(websocketURL);
      this.websocket = websocket;
      websocket.onopen = () => {
        // The server terminates sockets routinely (token expiry, missed pong), so the retry
        // budget only counts consecutive failures.
        this.reconnectAttempt = 0;
        console.log('Connected to message server.');
      };
      websocket.onclose = () => {
        if (this.websocket === websocket) this.websocket = null;
        this.scheduleReconnect();
      };
      websocket.onerror = () => console.log(`Disconnected from message server ${this.reconnectAttempt}/${MAX_RECONNECT_ATTEMPTS}.`);
      websocket.onmessage = evt => {
        const decodedData = parseJson(evt.data);
        if (!decodedData?.chat || !decodedData?.message) return;
        this.setState({ messages: _.concat(decodedData, this.state.messages) });
      };
    } catch {
      this.scheduleReconnect();
    }
  };

  scheduleReconnect = () => {
    if (this.isUnmounted || this.reconnectAttempt >= MAX_RECONNECT_ATTEMPTS) return;
    this.reconnectAttempt += 1;
    clearTimeout(this.reconnectTimer);
    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null;
      this.connectToWSS();
    }, 1000);
  };

  state = {
    messages: []
  };
  render() {
    const { messages } = this.state;
    return (
      <div className='chat-outer-container'>
        <div className='chat-inner-container'>
          {messages.map(({ chat, message }) => {
            return <ChatMessage key={message.id} chat={chat} message={message} />;
          })}
        </div>
      </div>
    );
  }
}

Chat.propTypes = {};

export default Chat;

export const getAdminWebSocketOptions = async () => {
  const websocketURL = getAdminWebSocketUrl();
  if (isE2ETest) {
    const csrfToken = getE2ETestCsrfToken();
    if (csrfToken) websocketURL.searchParams.set('csrfToken', csrfToken);
    return { websocketURL: websocketURL.toString() };
  }

  const session = await Auth.currentSession();
  const idToken = session.getIdToken().getJwtToken();
  return {
    websocketURL: websocketURL.toString(),
    protocols: [ADMIN_WEBSOCKET_PROTOCOL, `${ADMIN_WEBSOCKET_AUTH_PROTOCOL_PREFIX}${idToken}`]
  };
};

const getAdminWebSocketUrl = () => {
  if (process.env.REACT_APP_WEBSOCKET_URL) return new URL(process.env.REACT_APP_WEBSOCKET_URL);
  if (isDevelopment()) {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return new URL(`${protocol}//${window.location.host}/__chat_ws`);
  }
  throw new Error('REACT_APP_WEBSOCKET_URL must be set outside local development');
};
